import { api } from '@/lib/api'
import { signOut } from '@/lib/auth-client'

/**
 * Verify the current session belongs to a platform admin.
 * Signs the user out if they have a session but no admin access.
 * Returns the admin profile on success, null otherwise.
 */
export async function assertAdminOrSignOut() {
  const { data, error } = await api.admin.me.get()
  if (error || !data) {
    await signOut().catch(() => {})
    return null
  }
  return data
}
